import type { ResourceTypeHandle } from '@toolproof-core/genesis/_contract/_index';

import type { SpaceAdapter } from '@toolproof-core/visualization/adapter/_contract/adapter';

import { CONFIG } from '@/adapters/core/_data/config/config';
import { buildCosmosData } from '@/adapters/core/_pure/cosmosData';
import { getResourceTypeInputSpec } from '@/adapters/core/_pure/resourceTypeInputSpec';
import { episodePresentation } from '@/adapters/core/episodePresentation';
import { createCoreEpisodeEffectOwner } from '@/adapters/core/episodePlayback';
import { createSpaceDeriver } from '@/adapters/core/framePipeline';
import { runtimeController } from '@/adapters/core/runtime';
import { SPACE_KEY } from '@/adapters/core/spaceIdentity';
import type { SpaceAdapterDescriptor } from '@/_contract/types';
import type { Config, CosmosDataModel, RuntimeState } from '@/adapters/core/_contract/config';

export const spaceAdapter: SpaceAdapter<
    ResourceTypeHandle,
    CosmosDataModel,
    Config,
    RuntimeState
> = {
    createSpaceDeriver,
};

export const DESCRIPTOR = {
    withAgentChanges: (config: Config, changes: Config['agentChanges']): Config => ({ ...config, agentChanges: changes }),
    withAgentPlannedFiles: (config: Config, files: Config['agentPlannedFiles']): Config => ({ ...config, agentPlannedFiles: files }),
    createRuntimeEffectOwner: createCoreEpisodeEffectOwner,
    episodePresentation,
    baseDescriptor: {
        spaceKey: SPACE_KEY,
        adapter: spaceAdapter,
        getResourceTypeInputSpec,
        buildCosmosData,
        defaultConfig: CONFIG,
    },
    runtime: {
        kind: 'single',
        controller: runtimeController,
    },
} as const satisfies SpaceAdapterDescriptor<
    ResourceTypeHandle,
    CosmosDataModel,
    Config,
    RuntimeState
>;

export type AdapterDescriptor = typeof DESCRIPTOR;
